import styled from "styled-components";
import colors from "../../../../../config/colors";
import fonts from "../../../../../config/fonts";
import { isMobile } from "../../../../../utils/common";

export const NewsContainer = styled.div`
  position: fixed;
  top: 50px;
  right: 0px;
  height: calc(100vh - 50px);
  width: 350px;
  background-color: ${colors.darkPrimary};
  color: ${colors.background};
  z-index: 2;
  ${isMobile() &&
  `
        position:static;
        width:100vw;
        height:fit-content;
  `}
`;

export const NewsSegment = styled.div`
  height: 50%;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 20px;
  box-sizing: border-box;
  ${isMobile() &&
  `
        height:80vh;
  `}
`;
export const NewsSegmentHeading = styled.div`
  font-size: 16px;
  ${fonts.headings};
  font-weight: bold;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
`;
export const NewsList = styled.div`
  padding: 5px;
  background-color: ${colors.background};
  width: 100%;
  box-sizing: border-box;
  border-radius: 5px;
  height: 100%;
  overflow-y: scroll;
`;
export const NewsLine = styled.div`
  background-color: ${(props) =>
    props.color ? props.color : colors.darkBackground};
  margin: 5px;
  padding: 5px;
  color: ${colors.darkPrimary};
  font-size: 12px;
  border-radius: 5px;
`;

export const NewsText = styled.div``;
export const NewsTime = styled.div`
  text-align: right;
  font-size: 8px;
`;
